module.exports = "https://web-assets.ifttt.com/packs/media/docs/architecture_diagram-8e8dd23e.png";